export default "__VITE_ASSET__adc5cd4b__"